// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"url":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-3174ab52","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/developerInfo/components/mainContractNumberTag.vue
// module id = 2170
// module chunks = 68